import Response from "./Response";

const AjaxForm = {
    init() {
        $(document).on("beforeSubmit", "[data-ajax_form]", function (event) {
            event.preventDefault();
            AjaxForm.submit($(this));
        });

        $(document).on("submit", "[data-ajax_form]", function (event) {
            event.preventDefault();
        });
    },

    submit(form, confirmationParameter = null) {
        if (form.hasClass("is-submitting")) return;

        const data = new FormData(form[0]);
        if (confirmationParameter) data.append(confirmationParameter, "1");
        form.addClass("is-submitting");

        $.ajax({
            url: form.attr("action"),
            method: "POST",
            data,
            processData: false,
            contentType: false,
        })
            .done((response) => {
                if (!response.confirmation) {
                    Response.handle(response);
                    return;
                }

                Swal.fire({
                    title: response.confirmation.title,
                    text: response.confirmation.message,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#2185d0",
                    cancelButtonColor: "#78868f",
                    confirmButtonText: response.confirmation.confirmText,
                    cancelButtonText: "Anuluj",
                }).then((result) => {
                    if (result.isConfirmed) {
                        AjaxForm.submit(form, response.confirmation.parameter);
                    }
                });
            })
            .fail((xhr) => Response.error(xhr))
            .always(() => form.removeClass("is-submitting"));
    },
};

export default AjaxForm;
